import { axiosBasic } from "./axios";
import { config } from "./endPoints";
import { syncStoredUserInfoFromUserData } from "../utils/appLanguages";

const { Account } = config.REST_API;

/** Persist the signed-in user's primary (UI) language. */
export async function updatePrimaryLanguage(primaryLanguage) {
  const response = await axiosBasic.put(Account.UpdatePrimaryLanguage, {
    PrimaryLanguage: primaryLanguage,
  });
  return response.data;
}

/** Load account userdata and apply PrimaryLanguage (e.g. on app/header mount). */
export async function fetchAccountUserDetailsAndSyncLanguage(options = {}) {
  const { silent = false } = options;
  const response = await axiosBasic.get(Account.GetUserDetails, {
    skipApiExceptionCapture: silent,
  });
  const { success, data } = response.data ?? {};
  if (!success || !data) return null;
  return syncStoredUserInfoFromUserData(data);
}
